import { isValidBIC } from 'ibantools';
import { sanitizeToAlphanumeric } from './sanitizeToAlphanumeric';

export function formatRoutingNumberForServer(value: string): string {
  if (!value) {
    return '';
  }

  return sanitizeToAlphanumeric(value).toUpperCase();
}

export function validateBic(value: string): boolean {
  const formatted = formatRoutingNumberForServer(value);
  if (!formatted) {
    return true;
  }

  return isValidBIC(formatted);
}
